import { Tabs } from '@dittolive/anvil'
import { useLocation, useNavigate } from 'react-router-dom'

export type TabItem = {
  text: string
  to: string
  key: string
  onMouseEnter?: () => void
}
type Props = {
  items: Array<TabItem>
}

/** Tabs navigation component for the organization and application scenes. */
const TabsWrapper = ({ items }: Props) => {
  const { pathname } = useLocation()
  const slugs = pathname.split('/').filter(Boolean)
  const lastSlug = slugs[slugs.length - 1]
  const navigate = useNavigate()
  // NOTE: We started using subroutes in the app management pages, e.g. /connect/api-keys/new, and so
  // cannot solely rely on the last slug to determine the selected tab.
  const selected = items.find(
    ({ key, to }) => lastSlug === key || pathname.startsWith(to),
  )

  if (!selected) {
    return null
  }

  const handleChange = (id: string) => {
    const navigateToItem = items.find(({ key }) => key === id)
    if (navigateToItem?.to) {
      navigate(navigateToItem.to)
    }
  }

  return (
    <div className="mx-auto overflow-x-auto px-4 sm:max-w-7xl">
      <Tabs value={selected.key} onValueChange={handleChange}>
        <Tabs.List variant="pill">
          {items.map(({ text, key, onMouseEnter }) => (
            <Tabs.Trigger key={key} value={key} onMouseEnter={onMouseEnter}>
              {text}
            </Tabs.Trigger>
          ))}
        </Tabs.List>
      </Tabs>
    </div>
  )
}

export default TabsWrapper
